<template>
  <button
    @click="$emit('select')"
    class="context-choice-button bg-eggplant-50 dark:bg-eggplant-900 rounded-full px-3 py-1 text-sm font-medium text-eggplant-600 hover:bg-eggplant-100 dark:text-eggplant-400 dark:hover:bg-eggplant-800 transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-eggplant-500/20 focus:ring-offset-1"
  >
    {{ text }}
  </button>
</template>

<script setup lang="ts">
interface Props {
  description?: string;
  text: string;
}

defineProps<Props>();

defineEmits<{
  select: [];
}>();
</script>

<style scoped>
.context-choice-button {
  /* Smooth transitions for better UX */
  transition: all 0.2s ease;
}

.context-choice-button:hover {
  transform: translateY(-1px);
}

.context-choice-button:active {
  transform: translateY(0);
}
</style>
